module.exports = __webpack_public_path__ + "img/data.3c450111.png";